"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const IMAGE_SRC = "/image/new-version/casting/Sand-Casting/what-is-sand-casting.webp";

const GlobeIcon = () => (
	<svg
		aria-hidden
		className="h-14 w-14 flex-none text-themePrimary400 sm:h-16 sm:w-16 md:h-[72px] md:w-[72px] lg:h-20 lg:w-20"
		viewBox="0 0 48 48"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<circle cx="24" cy="24" r="20" />
		<ellipse cx="24" cy="24" rx="20" ry="8" />
		<ellipse cx="24" cy="24" rx="8" ry="20" />
	</svg>
);

export default function WhatIsSandCasting() {
	const t = useTranslations("new-sand-casting");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="relative mb-8 flex min-h-[72px] items-center sm:mb-10 sm:min-h-[80px] md:mb-12 md:min-h-[88px]">
					<h2 className="whitespace-pre-line text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("whatIsSandCastingTitle")}
					</h2>
					<div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center">
						<GlobeIcon />
					</div>
				</div>

				<div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:gap-12">
					<div className="flex w-full lg:min-w-0 lg:flex-1">
						<div className="relative aspect-[4/3] w-full overflow-hidden">
							<Image
								src={IMAGE_SRC}
								alt={t("whatIsSandCastingImageAlt")}
								fill
								className="object-cover"
								sizes="(max-width: 1024px) 100vw, 50vw"
							/>
						</div>
					</div>

					<div className="flex w-full flex-col lg:min-w-0 lg:flex-1">
						<div className="space-y-4 text-sm leading-relaxed text-black md:text-base">
							<p>{t("whatIsSandCastingDesc1")}</p>
							<p>{t("whatIsSandCastingDesc2")}</p>
							<p>{t("whatIsSandCastingDesc3")}</p>
						</div>
						<div className="mt-6 sm:mt-8">
							<Link
								href="/upload"
								className="inline-flex items-center justify-center rounded-md bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90 sm:text-base"
							>
								{t("whatIsSandCastingGetQuote")}
							</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
